/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import MasqService from 'cio/services/masq';

interface SettingsSubscriptionCancelAccountModalArgs {
  onClose: () => unknown;
  cancelAccountAction: () => unknown;
}
export default class SettingsSubscriptionCancelAccountModal extends Component<SettingsSubscriptionCancelAccountModalArgs> {
  @service masq!: MasqService;

  @tracked cancellationFeedback = '';
}
